import classnames from 'classnames/bind'
import { useTranslate } from 'react-polyglot'
import { GlobalThemeColors } from '~/@types/colors'
import { GlobalTextPreset } from '~/@types/text-preset'

import { UnlikelyMoney } from '@unlikelystudio/commerce-connector'

import { useStyle } from '~/providers/StyleProvider'

import useLocale from '~/hooks/useLocale'

import { PRODUCT } from '~/data/dictionary'
import serializePrice from '~/data/serialize-price'

import css from './styles.module.scss'

const cx = classnames.bind(css)

export type ProductInfosProps = {
  className?: string
  productName: string
  smallDescription?: string
  bigDescription?: string
  availableForSale?: boolean
  price?: UnlikelyMoney
  compareAtPrice?: UnlikelyMoney
  hasMultipleVariants?: boolean
  isGiftCard?: boolean
}

function ProductInfos({
  className,
  smallDescription,
  bigDescription,
  productName,
  price,
  compareAtPrice,
  hasMultipleVariants,
  isGiftCard,
}: ProductInfosProps) {
  const t = useTranslate()
  const locale = useLocale()
  const titleTextStyle = useStyle({
    textPreset: GlobalTextPreset.Title22Primary,
  })
  const categoryTextPreset = useStyle({
    textPreset: GlobalTextPreset.Text18Secondary,
    color: GlobalThemeColors.Gray1ToBlack,
  })

  const compareAtPriceTextStyle = useStyle({
    textPreset: GlobalTextPreset.Label12Secondary,
  })

  const priceStyle = useStyle({
    textPreset: GlobalTextPreset.Label18PrimaryReg,
    color: GlobalThemeColors.Black,
  })

  return (
    <div className={cx(css.ProductInfos, className)}>
      <div className={cx(css.titleRow)}>
        <h1 className={cx(css.title, titleTextStyle)}>{productName}</h1>
        {!isGiftCard && (
          <span className={cx(css.priceSection, categoryTextPreset)}>
            {hasMultipleVariants && price && t(PRODUCT.PRICE_FROM)}
            {compareAtPrice && (
              <del className={cx(compareAtPriceTextStyle, css.compareAtPrice)}>
                {serializePrice(
                  locale,
                  compareAtPrice?.currencyCode,
                  compareAtPrice?.amount,
                )}
              </del>
            )}
            <span className={cx(css.price, priceStyle)}>
              {serializePrice(locale, price?.currencyCode, price?.amount)}
            </span>
          </span>
        )}
      </div>
      <div className={cx(css.aboveTitle, categoryTextPreset)}>
        <span
          className={cx(css.featuredCategory, {
            hasSmallCategory: smallDescription?.length > 0,
          })}>
          {`${smallDescription ?? t(PRODUCT.PRICE_FROM)}`}
        </span>
      </div>
      {bigDescription && (
        <div className={cx(css.bigDescription, categoryTextPreset)}>
          <p>{bigDescription}</p>
        </div>
      )}
    </div>
  )
}

ProductInfos.defaultProps = {}

export default ProductInfos
